import { Button } from '@/components/ui/button';


export const YOUTUBE_CHANNEL_URL = 'https://www.youtube.com/@improteatern';

interface YouTubeButtonProps {
  className?: string;
}

export default function YouTubeButton({ className = '' }: YouTubeButtonProps) {
  return (
    <Button variant="default" asChild className={className}>
      <a href={YOUTUBE_CHANNEL_URL} target="_blank" rel="noopener noreferrer">
        <span>Se oss på Youtube</span>
      </a>

    </Button>
  );
}
